import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
	query GetProducts {
		products(filter: { deletedAt: { isNull: true } }, orderBy: NAME_ASC) {
			nodes {
				id
				imageSrc
				name
				description
				variants(filter: { deletedAt: { isNull: true } }) {
					nodes {
						id
						name
						price
						available
					}
				}
			}
		}
	}
`;

export const GET_PRODUCTS_BY_COLLECTION = gql`
	query GetProductsByCollection($collectionId: [UUID]!) {
		productCollection(pCollectionId: $collectionId) {
			nodes {
				id
				imageSrc
				name
				description
				variants(filter: { deletedAt: { isNull: true } }) {
					nodes {
						id
						name
						price
						available
					}
				}
			}
		}
	}
`;

export const GET_VARIANT = gql`
	query GetVariant($id: UUID!) {
		variant(id: $id) {
			id
			name
			price
			product {
				id
				name
				description
				imageSrc
			}
		}
	}
`;
